function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#f15f67;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__dollar-sign",
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_2",
  d: "M0 0L0 26.875",
  className: "prefix__cls-1",
  "data-name": "Line 2",
  transform: "translate(7.33)"
}), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_4",
  d: "M19.438 5h-9.162a4.276 4.276 0 1 0 0 8.551h6.108a4.276 4.276 0 1 1 0 8.551H6",
  className: "prefix__cls-1",
  "data-name": "Path 4",
  transform: "translate(-6 -.114)"
}));

var SvgDollarSign = function SvgDollarSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.66,
    height: 29.875,
    viewBox: "0 0 17.66 29.875",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollarSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar-sign.8e714621.svg";
export { ForwardRef as ReactComponent };